import { useState, useEffect } from "react";
import axios from "axios";
import { FaCheck, FaTimes } from "react-icons/fa";
import NavBar from "../components/NavBar";
import { useNavigate, useParams } from "react-router-dom";
import LoadingScreen from "../components/LoadingScreen";
import logo from "../img/logo.png"

const PilihPakej = () => {
  const { id } = useParams();
  const [features, setFeatures] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/features/all`);

        // Ensure features is an array
        const featureData = Array.isArray(response.data) ? response.data : response.data.data || [];
        setFeatures(featureData);
      } catch (error) {
        console.error("Error fetching features:", error);
        setError("Failed to load packages.");
      } finally {
        setLoading(false);
      }
    };

    fetchFeatures();
  }, []);

  return (
    <div>
      <NavBar />
      {loading && <LoadingScreen logo={logo} />}
      <div className="container mx-auto px-5 py-40 max-w-5xl">
        <h2 className="text-3xl font-bold text-center mb-12">Pilih Pakej</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="border rounded-2xl p-6 shadow-lg cursor-pointer transition hover:shadow-2xl"
            >
              <h3 className="text-xl font-bold text-center mb-4 uppercase">{feature.pakej}</h3>
              <div className="text-center mb-4">
                <span className="text-2xl font-bold text-black">RM{feature.sale_price}</span>
                <span className="text-gray-500 line-through ml-2">RM{feature.normal_price}</span>
              </div>
              <ul className="space-y-2">
                <FeatureItem label="Tukar Tema Tanpa Had" value={feature.tema} />
                <FeatureItem label="Background Music" value={feature.music} />
                <FeatureItem label="One-click Call/WhatsApp" value={feature.contacts} />
                <FeatureItem label="One-click Waze/Google Maps" value={feature.direction} />
                <FeatureItem label="Countdown" value={feature.countdown} />
                <FeatureItem label="RSVP" value={feature.rsvp} />
                <FeatureItem label="Money Gift" value={feature.money_gift} />
                <FeatureItem label="Guestbook" value={feature.guestbook} />
                <FeatureItem label="Photo Gallery" value={feature.galleries} />
                <FeatureItem label="Versi PDF" value={feature.pdf} />
              </ul>
              <button
                onClick={() => navigate(`/checkout/${id}/${feature.pakej}`)}
                className="btn-primary mt-4 w-full py-2 rounded-lg transition"
              >
                Pilih Ini
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const FeatureItem = ({ label, value }) => (
  <li className="flex items-center justify-between border-b py-2">
    <span className="text-gray-600">{label}</span>
    {value == 1 ? <FaCheck className="text-green-500" /> : <FaTimes className="text-red-500" />}
  </li>
);

export default PilihPakej;
